"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectColorOptions = exports.getColor = void 0;
var ui_symbols_1 = require("@hopin-team/ui-symbols");
var Groups;
(function (Groups) {
    Groups["Theme"] = "THEME";
    Groups["Utility"] = "UTILITY";
    Groups["Grey"] = "GREY";
    Groups["Blue"] = "BLUE";
    Groups["Red"] = "RED";
    Groups["Green"] = "GREEN";
    Groups["Orange"] = "ORANGE";
    Groups["Yellow"] = "YELLOW";
    Groups["Purple"] = "PURPLE";
})(Groups || (Groups = {}));
var colorPropRegex = /^(theme|utility|grey|blue|red|green|orange|yellow|purple)-(\w*)$/;
var isValidGroup = function (value) {
    if (!(value in ui_symbols_1.COLOR)) {
        console.warn("\"".concat(value, "\" is not a valid option for color groups.\n      Valid options are: ").concat(Object.keys(Groups), "."));
    }
    return value in ui_symbols_1.COLOR;
};
function isValid(value, group) {
    var isValid = value in ui_symbols_1.COLOR[group];
    if (!isValid) {
        console.warn("\"".concat(value, "\" is not a valid option for ").concat(group, " colors. Valid options are: ").concat(Object.keys(ui_symbols_1.COLOR[group])
            .map(function (c) { return c.toLowerCase(); })
            .join(', '), "."));
    }
    return isValid;
}
var getColor = function (color, theme) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    // Match
    var match = color.match(colorPropRegex);
    // Group
    var _group = (_a = match === null || match === void 0 ? void 0 : match[1].toUpperCase()) !== null && _a !== void 0 ? _a : '';
    var group = isValidGroup(_group) ? _group : Groups.Grey;
    // Shade
    var shade = (_b = match === null || match === void 0 ? void 0 : match[2].toUpperCase()) !== null && _b !== void 0 ? _b : '';
    switch (group) {
        case Groups.Grey: {
            if (isValid(shade, group)) {
                return (_d = (_c = theme === null || theme === void 0 ? void 0 : theme.COLOR) === null || _c === void 0 ? void 0 : _c[group][shade]) !== null && _d !== void 0 ? _d : ui_symbols_1.COLOR[group][shade];
            }
            break;
        }
        case Groups.Theme: {
            if (isValid(shade, group)) {
                return (_f = (_e = theme === null || theme === void 0 ? void 0 : theme.COLOR) === null || _e === void 0 ? void 0 : _e[group][shade]) !== null && _f !== void 0 ? _f : ui_symbols_1.COLOR[group][shade];
            }
            break;
        }
        case Groups.Utility: {
            if (isValid(shade, group)) {
                return (_h = (_g = theme === null || theme === void 0 ? void 0 : theme.COLOR) === null || _g === void 0 ? void 0 : _g[group][shade]) !== null && _h !== void 0 ? _h : ui_symbols_1.COLOR[group][shade];
            }
            break;
        }
        case Groups.Blue:
        case Groups.Red:
        case Groups.Green:
        case Groups.Orange:
        case Groups.Yellow:
        case Groups.Purple: {
            if (isValid(shade, group)) {
                return (_k = (_j = theme === null || theme === void 0 ? void 0 : theme.COLOR) === null || _j === void 0 ? void 0 : _j[group][shade]) !== null && _k !== void 0 ? _k : ui_symbols_1.COLOR[group][shade];
            }
            break;
        }
    }
    return (_m = (_l = theme === null || theme === void 0 ? void 0 : theme.COLOR) === null || _l === void 0 ? void 0 : _l[group]['DEFAULT']) !== null && _m !== void 0 ? _m : ui_symbols_1.COLOR[group]['DEFAULT'];
};
exports.getColor = getColor;
// NOTE: Currently, Storybook Controls doesn’t generate a proper select menu for
// long types like ColorProp. The selectColorOptions const helps you to force
// Storybook to show a select menu by manually passing it into
// argTypes.color.control.options.
exports.selectColorOptions = [
    'theme-primary',
    'theme-secondary',
    'theme-tertiary',
    'utility-action',
    'utility-error',
    'utility-error_inverse',
    'utility-warn',
    'utility-success',
    'grey-black',
    'grey-dark',
    'grey-medium',
    'grey-light',
    'grey-white',
    'grey-900',
    'grey-800',
    'grey-700',
    'grey-600',
    'grey-500',
    'grey-400',
    'grey-300',
    'grey-200',
    'grey-100',
    'blue-100',
    'blue-200',
    'blue-300',
    'blue-400',
    'blue-500',
    'red-100',
    'red-200',
    'red-300',
    'red-400',
    'red-500',
    'red-600',
    'green-100',
    'green-200',
    'green-300',
    'green-400',
    'green-500',
    'green-600',
    'orange-100',
    'orange-200',
    'orange-300',
    'orange-400',
    'orange-500',
    'yellow-100',
    'yellow-200',
    'yellow-300',
    'yellow-400',
    'yellow-500',
    'yellow-600',
    'purple-100',
    'purple-200',
    'purple-300',
    'purple-400',
    'purple-500',
];
//# sourceMappingURL=get-color.js.map